module.exports = __webpack_public_path__ + "static/media/menu-plus-icon.715cbe59.png";